import React from 'react';
import {Input, PhoneInput} from '../../form'
import {FormTemplateHeader, FormTemplateField, FormTemplateSectionWrapper} from '../../others/'

const PrimaryPhysicianTab = (props)=> {
  const {template, isTemplate} = props
  return(
    <div>
      {template && template.personal_information &&
        <div>
          <FormTemplateSectionWrapper isTemplate={isTemplate} fieldValues={template.personal_information.primary_physician}>
            <div className="row mx-0 mt-7 bg-white shadow-sm">
              <div className="col-12 px-5 pt-5">
                <FormTemplateHeader 
                  isTemplate={isTemplate} 
                  fieldValues={template.personal_information.primary_physician} 
                  baseName="personal_information[primary_physician]"/>
              </div>
              <div className="col-12 px-7">
                <div className="row">
                  <FormTemplateField
                    isTemplate={isTemplate}
                    isOpen={true}
                    name="primary_physician[primary_doctor]"
                    baseName="personal_information[primary_physician][fields][primary_doctor]"
                    fieldValues={template.personal_information.primary_physician.fields.primary_doctor}
                    component={Input} 
                    className="form-control"
                    wrapperClasses="col-6 form-group"
                   />

                  <FormTemplateField
                    isTemplate={isTemplate}
                    isOpen={true}
                    name="primary_physician[phone_number]"
                    baseName="personal_information[primary_physician][fields][phone_number]"
                    fieldValues={template.personal_information.primary_physician.fields.phone_number}
                    component={PhoneInput} 
                    isPhoneInput={true}
                    className="form-control"
                    wrapperClasses="col-6 form-group"
                   />

                  <FormTemplateField
                    isTemplate={isTemplate}
                    isOpen={true}
                    name="primary_physician[primary_pharmacy]"
                    baseName="personal_information[primary_physician][fields][primary_pharmacy]"
                    fieldValues={template.personal_information.primary_physician.fields.primary_pharmacy}
                    component={Input} 
                    className="form-control"
                    wrapperClasses="col-6 form-group"
                   />

                  <FormTemplateField
                    isTemplate={isTemplate}
                    isOpen={true}
                    name="primary_physician[secondary_pharmacy]"
                    baseName="personal_information[primary_physician][fields][secondary_pharmacy]"
                    fieldValues={template.personal_information.primary_physician.fields.secondary_pharmacy}
                    component={Input} 
                    className="form-control"
                    wrapperClasses="col-6 form-group"
                   />
                 
                </div>
              </div>
            </div>
          </FormTemplateSectionWrapper>
        </div>
      }
    </div>
  )
}

export default PrimaryPhysicianTab;
